import _implicitStylesheets from "./gtmNoScript.css";
import _implicitScopedStylesheets from "./gtmNoScript.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<noscript${3}>&lt;iframe src=&quot;https://www.googletagmanager.com/ns.html?id=GTM-WH23RMD&quot; height=&quot;0&quot; width=&quot;0&quot; style=&quot;display: none; visibility: hidden&quot; &gt;&lt;/iframe&gt;</noscript>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-lgor9b37up";
tmpl.legacyStylesheetToken = "undefined-_gtmNoScript";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
